/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-19 15:07:31
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-04-19 15:07:42
 * @FilePath: /unifyxp-v2-store-portal/src/components/Buttons/index.ts
 */
export { default as AddIconButton } from './AddIconButton';
